// extracted by mini-css-extract-plugin
module.exports = {"bold":"src_bold__1jzOH"};